export function mailValidate(target: string): boolean {
  const pattern =
    /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  return pattern.test(target);
}

export function phoneNumberValidate(target: string) {
  const pattern1 = /^[0-9０-９-ー+＋¥-ー]+$/;
  const pattern2 = /^.*[0-9０-９]{3,}.*$/;
  return pattern1.test(target) && pattern2.test(target);
}

/** バリデーターを受け取ってaddTagでバリデートを行うメソッド */
export const testValidate = (
  text: string,
  validator: ((t: string) => boolean) | undefined
) => (validator ? validator(text) : true);

export const lengthValidate = (text: string, limit: number) => {
  let textLength = 0;
  for (const char of text) {
    // ASCII characters are in the range \u0000-\u007F (1 byte each)
    if (char.charCodeAt(0) <= 0x7f) {
      textLength += 1;
    } else {
      // Non-ASCII characters (treated as 2 bytes)
      textLength += 2;
    }
  }
  return textLength <= limit;
};

export const idValidate = (id: string) => {
  return /^[a-z0-9]([a-z0-9-]{1,18}[a-z0-9])?$/.test(id);
};
